// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Nqt5","amount":"Amount_amount__1bq3e","tip":"Amount_tip__2ZtvL","tipHeader":"Amount_tipHeader__1crcb","tipsWrap":"Amount_tipsWrap__22IwF"};